export default {
  // 画面別
  password: 'メールアドレス又はパスワードが一致しません',
  old_password: '古いパスワードが一致しません',
  code: 'メールアドレス又は認証コードが無効です',
  file: 'アップロードするファイルがありません',
  status: 'ステータス変更に失敗しました',

  // データ無し
  user: 'ユーザーが存在しません',
  personal: 'ユーザー設定が存在しません',
  product: '製品情報が存在しません',
  upload: 'ファイルが存在しません',
  post: '投稿が存在しません',

  // 共通
  connect: '通信に失敗しました',
  transaction: 'データ取得中にエラーが発生しました',
  illegal: '予期しないエラーが発生しました',
  login: 'ログインされていません',
  auth: '自動的にログアウトされました',
  level: 'ログイン認証レベルが不足しています',

  // SQL共通
  sql_search: '検索結果が取得できません',
  sql_find: 'データが取得できません',
  sql_add: '登録に失敗しました',
  sql_update: '更新に失敗しました',
  sql_delete: '削除に失敗しました',
};
